import ApartmentsListTile from './ApartmentsListTile.vue';

export { ApartmentsListTile };
export default ApartmentsListTile;
